import React from 'react'
import PropTypes from 'prop-types'
import { Paragraph } from './styles'

Content.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string
    })
  }).isRequired
}

export default function Content({ content }) {
  return (
    <Paragraph
      dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }}
    />
  )
}
